document.addEventListener('alpine:init', function () {
    Alpine.data('header', function () {
        return {
            mobileMenuOpen: false,
            desktopMenuOpen: null,
            desktopMenuHeight: null,
            searchOpen: false,
            searchQuery: '',
            desktopSubmenu: null,
            activeRelatedItem: '',
            toggleMobileMenu: function (force) {
                if (typeof force === 'boolean') {
                    this.mobileMenuOpen = force;
                }
                else {
                    this.mobileMenuOpen = !this.mobileMenuOpen;
                }
                if (this.mobileMenuOpen) {
                    this.searchOpen = false;
                }
                document.body.classList.toggle('overflow-hidden', this.mobileMenuOpen);
            },
            toggleDesktopMenu: function (index) {
                if (this.desktopMenuOpen === index || index === '') {
                    this.desktopMenuOpen = null;
                }
                else {
                    this.desktopMenuOpen = index;
                }
                if (this.desktopMenuOpen) {
                    this.searchOpen = false;
                }
                document.body.classList.toggle('overflow-hidden', this.desktopMenuOpen);
                // Reset the height
                this.desktopMenuHeight = 0;
                this.setRelatedItems('');
            },
            toggleSearchMenu: function (force) {
                var _this = this;
                this.toggleMobileMenu(false);
                this.toggleDesktopMenu('');
                if (typeof force === 'boolean') {
                    this.searchOpen = force;
                }
                else {
                    this.searchOpen = !this.searchOpen;
                }
                // After a short delay, focus on the field.
                setTimeout(function () {
                    _this.searchOpen && _this.$refs.searchField.focus();
                }, 500);
            },
            openDesktopSubmenu: function (id) {
                this.desktopSubmenu = id;
            },
            setRelatedItems: function (id) {
                var _this = this;
                this.activeRelatedItem = id;
                // Perform a calculation to determine the height of the 'related items' to ensure we set the height.
                setTimeout(function () {
                    var newHeight = 0;
                    var activeMenuItem = _this.$root.querySelector('.active-menu-item');
                    if (activeMenuItem) {
                        var activeRelatedItems = activeMenuItem.querySelector('.active-related-items');
                        newHeight = activeRelatedItems ? activeRelatedItems.clientHeight : 0;
                        // Make sure that the larger height gets used
                        if (newHeight !== 0) {
                            newHeight = Math.max(activeMenuItem.clientHeight, newHeight);
                        }
                    }
                    _this.desktopMenuHeight = newHeight;
                }, 20);
            },
        };
    });
});
